module.exports = __webpack_public_path__ + "static/media/Creative Agency.a14d68b1.png";